import { useEffect, useState, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "../assets/searchIcon.svg";
import Select from "react-select";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import CustomPagination from "../utils/paginationUtils";

import "./RpaReport.scss";
import { ReportServices } from "../services/ReportServices";
import { HospitalServices } from "../services/HospitalServices";
import { CircularProgress } from "@mui/material";
import formatDateTimeLocal from "../utils/formatDateTimeUtil";
const RpaCaseWiseReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [orderBy, setOrderBy] = useState("DESC");
  const [hospitalList, setHospitalList] = useState([]);
  const [hospitalId, setHospitalId] = useState("");
  const [caseStatus, setCaseStatus] = useState("STATUS_UPDATE");
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [processedBy, setProcessedBy] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortByTime, setSortByTime] = useState("processTime");
  const [filterByDateType, setFilterByDateType] = useState("createdAt");
  let prevDate = new Date();
  prevDate.setDate(prevDate.getDate() - 1);
  const [startDate, setStartDate] = useState(formatDateTimeLocal(prevDate));
  const [endDate, setEndDate] = useState(formatDateTimeLocal(new Date()));
  let limit = 10;
  const searchTimeRef = useRef();
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearTimeout(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log("start date:", startDate);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  function getTime(totalSeconds) {
    // const totalSeconds = minutes * 60;

    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    let result = "";

    if (days > 0) result += `${days}D: `;
    if (hours > 0 || days > 0) result += `${hours}H: `;
    if (mins > 0 || hours > 0 || days > 0) result += `${mins}M: `;

    return result + secs + "S";
  }
  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  function formatDateTime(isoString, useLocalTime = true) {
    const date = new Date(isoString);

    const pad = (num) => String(num).padStart(2, "0");

    const day = pad(useLocalTime ? date.getDate() : date.getUTCDate());
    const month = pad(
      (useLocalTime ? date.getMonth() : date.getUTCMonth()) + 1
    );
    const year = useLocalTime ? date.getFullYear() : date.getUTCFullYear();

    let hours = useLocalTime ? date.getHours() : date.getUTCHours();
    const minutes = pad(
      useLocalTime ? date.getMinutes() : date.getUTCMinutes()
    );
    const seconds = pad(
      useLocalTime ? date.getSeconds() : date.getUTCSeconds()
    );

    // convert to 12-hour format
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // 0 → 12, 13–23 → 1–11

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getReportData = async () => {
    setLoading(true);
    try {
      const response = await ReportServices.getRpaCaseWiseReport(
        startDate,
        endDate,
        hospitalId,
        page,
        caseStatus,
        searchKey,
        sortByTime,
        filterByDateType,
        processedBy,
        orderBy
      );
      setReportData(response?.data?.requests);
      setTotalPages(response?.data?.totalPages);
      setTotalCount(response?.data.total);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getHospitalList();
  }, []);
  useEffect(() => {
    getReportData();
  }, [
    page,
    searchKey,
    startDate,
    endDate,
    hospitalId,
    caseStatus,
    sortByTime,
    filterByDateType,
    processedBy,
    orderBy,
  ]);
  console.log("");
  return (
    <div className="manage-box w-full overflow-hidden">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp;RPA Case Wise Report
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">RPA Case Wise Report ({totalCount})</div>
        <div className="flex gap-2 items-center">
          <Select
            name="orderBy"
            isClearable
            options={[
              { label: "Descending", value: "DESC" },
              { label: "Ascending", value: "ASC" },
            ]}
            // getOptionLabel={(options) => options["label"]}
            // getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setOrderBy(item.value) : setOrderBy("DESC");
            }}
            value={[
              { label: "Descending", value: "DESC" },
              { label: "Ascending", value: "ASC" },
            ].filter((option) => option.value === orderBy)}
            placeholder="ORDER BY"
          />
          <Select
            name="sortByTime"
            isClearable
            options={[
              { label: "RPA Process Time", value: "rpaProcessTime" },
              { label: "Process Time", value: "processTime" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setSortByTime(item.value) : setSortByTime("");
            }}
            value={[
              { label: "RPA Process Time", value: "rpaProcessTime" },
              { label: "Process Time", value: "processTime" },
            ].filter((option) => option.value === sortByTime)}
            placeholder="SORT BY TIME"
          />
          <Select
            name="dateType"
            isClearable
            options={[
              { label: "Created At", value: "createdAt" },
              { label: "Updated At", value: "updatedAt" },
            ]}
            getOptionLabel={(options) => options["label"]}
            getOptionValue={(options) => options["value"]}
            onChange={(item) => {
              setPage(1);
              item ? setFilterByDateType(item.value) : setFilterByDateType("");
            }}
            value={[
              { label: "Created At", value: "createdAt" },
              { label: "Updated At", value: "updatedAt" },
            ].filter((option) => option.value === filterByDateType)}
            placeholder="Filter By Date Type"
          />
        </div>
      </div>
      <div className="flex justify-between items-end">
        <div className="flex gap-3 flex-wrap">
          <div>
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="datetime-local"
              id="start-date"
              // value={formatDate(startDate)}
              value={startDate}
              onChange={handleStartDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>

          <div>
            <label htmlFor="end-date">End Date:</label>
            <input
              type="datetime-local"
              id="end-date"
              // value={formatDate(endDate)}
              value={endDate}
              onChange={handleEndDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>
          <div className="w-[25%]">
            <Select
              name="hospitalId"
              isClearable
              options={hospitalList}
              getOptionLabel={(options) => {
                return options["name"];
              }}
              getOptionValue={(options) => {
                return options["id"];
              }}
              onChange={(item) => {
                // setPage(1);
                item ? setHospitalId(item.id) : setHospitalId("");
              }}
              value={hospitalList.filter((item) => item.id === hospitalId)}
              placeholder="FILTER HOSPITAL WISE"
            />
          </div>
          <div className="w-[25%]">
            <Select
              name="status"
              isClearable
              options={[
                { label: "New Case", value: "NEW_CASE" },
                { label: "Status Update", value: "STATUS_UPDATE" },
                { label: "Upload Document", value: "UPLOAD_DOCUMENT" },
              ]}
              getOptionLabel={(options) => {
                return options["label"];
              }}
              getOptionValue={(options) => {
                return options["value"];
              }}
              onChange={(item) => {
                // setPage(1);
                item ? setCaseStatus(item.value) : setCaseStatus("");
              }}
              value={[
                { label: "New Case", value: "NEW_CASE" },
                { label: "Status Update", value: "STATUS_UPDATE" },
                { label: "Upload Document", value: "UPLOAD_DOCUMENT" },
              ].filter((item) => item.value === caseStatus)}
              placeholder="FILTER STATUS WISE"
            />
          </div>
          <div className="w-[25%]">
            <Select
              name="processedBy"
              isClearable
              options={[
                { label: "Manually", value: "MANUALLY" },
                { label: "RPA", value: "RPA" },
              ]}
              getOptionLabel={(options) => options["label"]}
              getOptionValue={(options) => options["value"]}
              onChange={(item) => {
                setPage(1);
                item ? setProcessedBy(item.value) : setProcessedBy("");
              }}
              // value={[
              //   { label: "Manually", value: "MANUALLY" },
              //   { label: "RPA", value: "RPA" },
              // ].filter((option) => option.value === caseStatus)}
              placeholder="PROCESSED BY"
            />
          </div>
        </div>
        <div
          style={{ border: "1px solid #E4E4E4" }}
          className="w-[270px] flex gap-1 items-center py-1 px-2 rounded-[4px]"
        >
          <img src={SearchIcon} alt="search-icon" />
          <input
            type="text"
            onChange={handleSearch}
            className="w-full border-none outline-none"
            placeholder="Patient Name / Beneficiary Number"
          />
        </div>
      </div>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />
      <div
        style={{ border: "1px solid #e4e4e4", marginTop: "24px" }}
        className="min-h-[50vh] rounded-[16px] p-5 overflow-x-auto"
      >
        {loading ? (
          <div className="flex justify-center">
            <CircularProgress />
          </div>
        ) : (
          <div>
            <div
              className={`grid grid-cols-11  text-[#797979] text-[12px] xl:text-[14px] 2xl:text-[16px]  px-4 2xl:px-8`}
            >
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  Hospital name
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Case Type
                </div>{" "}
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Process By
                </div>{" "}
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Patient Name{" "}
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Beneficiary No
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Registered ID
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Request On
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Update on CC
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Request Duration
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Update on TMS
                </div>
              </div>
              <div>
                <div className="text-[#191919] font-semibold mb-4">
                  {" "}
                  Process Duration
                </div>
              </div>
            </div>
            {reportData?.length > 0 ? (
              reportData?.map((rep, idx) => {
                return (
                  <div
                    key={idx}
                    className={`py-6 px-4 2xl:px-8 rounded-[16px] ${
                      idx % 2 === 0 ? "bg-white" : "bg-[#F7F7F7]"
                    }`}
                  >
                    <div
                      className={`grid grid-cols-11  text-[#797979] text-[12px] xl:text-[14px] 2xl:text-[16px]  `}
                    >
                      <div>
                        <div>{rep?.hospital?.name || "--"}</div>
                      </div>
                      <div>
                        <div>{rep?.caseStatus?.replace(/_/g, " ") || "--"}</div>
                      </div>
                      <div>
                        <div>{rep?.processedBy || "--"}</div>
                      </div>
                      <div>
                        <div>
                          {rep.submasterstagestatuses?.case?.patient
                            ?.patientName || "--"}
                        </div>
                      </div>
                      <div
                        title={
                          rep.submasterstagestatuses?.case?.patient
                            ?.beneficiaryNo
                        }
                      >
                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                          {rep.submasterstagestatuses?.case?.patient
                            ?.beneficiaryNo || "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {rep.submasterstagestatuses?.case
                            ?.pmjayRegistrationId || "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {rep?.createdAt
                            ? formatDateTime(rep?.createdAt)
                            : "--"}
                        </div>
                      </div>
                      <div>
                        <div>
                          {rep?.completionDate
                            ? formatDateTime(rep?.completionDate)
                            : "--"}
                        </div>
                      </div>
                      <div>
                        <div>{getTime(rep?.processTime) || "--"}</div>
                      </div>
                      <div>
                        <div>
                          {rep?.tmsStageUpdateTime
                            ? formatDateTime(rep?.tmsStageUpdateTime)
                            : "--"}
                        </div>
                      </div>
                      <div>
                        <div>{getTime(rep?.rpaProcessTime) || "--"}</div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
                No Data Found
              </div>
            )}
          </div>
        )}

        <div className="flex justify-center mt-4">
          <CustomPagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </div>
    </div>
  );
};

export default RpaCaseWiseReport;
